import React from 'react'

import { useSelector } from 'react-redux'

import { MenuExperiencePage } from 'routes/Menu/MenuExperience/MenuExperiencePage'
import { MenuRecipesPageWrapper } from 'routes/Menu/MenuRecipesPage'
import { getIsAuthenticated } from 'selectors/auth'

import { useIsCategoryComprehensionEnabled } from './hooks/useIsCategoryComprehensionEnabled'

type MenuRouterProps = {
  params: {
    orderId?: string
  }
  location: {
    query: Record<string, unknown>
  }
}

export const MenuRouter = ({ params, location }: MenuRouterProps) => {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const isCategoryComprehensionEnabled = useIsCategoryComprehensionEnabled()

  if (isAuthenticated || isCategoryComprehensionEnabled) {
    return <MenuExperiencePage params={params} location={location} />
  }

  return <MenuRecipesPageWrapper params={params} location={location} />
}
